(function() {
  'use strict';

  function openModal(slide, youtubeId, videoFull) {
    // Remove all existing modals
    var existingModals = document.querySelectorAll('.youtube-video-modal');
    Array.prototype.forEach.call(existingModals, function(modal){
      modal.remove();
    });

    if (slide.querySelector('.youtube-video-modal')) return;

    var modal = document.createElement('div');
    modal.className = 'youtube-video-modal';

    var closeBtn = document.createElement('button');
    closeBtn.className = 'close-modal';
    closeBtn.innerHTML = '<span></span>';

    closeBtn.onclick = function(ev) {
      ev.stopPropagation();
      modal.remove();
    };
    modal.appendChild(closeBtn);

    if (youtubeId) {
      var isVerticalVideo = slide.classList.contains('vertical-video');
      var width = isVerticalVideo ? "720" : "1280";
      var height = isVerticalVideo ? "1280" : "720";

      var iframe = document.createElement('iframe');
      iframe.src = "https://www.youtube-nocookie.com/embed/" + youtubeId + "?autoplay=1&fs=0&si=OOEmmly9ijcx9M8D";
      iframe.title = "YouTube video player";
      iframe.frameBorder = "0";
      iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
      iframe.allowFullscreen = false;
      iframe.width = width;
      iframe.height = height;
      iframe.style.width = '100%';
      iframe.style.height = '100%';
      iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');

      modal.appendChild(iframe);
    } else if (videoFull) {
      var video = document.createElement('video');
      video.src = videoFull;
      video.autoplay = true;
      video.playsInline = true;
      video.controls = true;
      video.disablePictureInPicture = true;
      video.setAttribute('controlsList', 'nodownload nofullscreen');
      video.style.width = '100%';
      video.style.height = '100%';
      video.style.objectFit = 'contain';
      modal.appendChild(video);

      // Set video volume from file or default to 0.4
      var bgPhoto = slide.querySelector('.video-block__background-photo');
      if (bgPhoto) {
        var volume = bgPhoto.getAttribute('data-video-full-volume');
        volume = volume ? parseFloat(volume) : 0.4;
        video.volume = volume;
      }
    }

    slide.appendChild(modal);
  }

  function initVideoBlockCarousel(carouselEl) {
    // Read initial slide data attributes per breakpoint
    var initialSlideLarge = parseInt(carouselEl.getAttribute('data-initial-slide-large'), 10);
    var initialSlideDesktop = parseInt(carouselEl.getAttribute('data-initial-slide-desktop'), 10);
    var initialSlideLaptop = parseInt(carouselEl.getAttribute('data-initial-slide-laptop'), 10);
    var initialSlideTablet = parseInt(carouselEl.getAttribute('data-initial-slide-tablet'), 10);
    var initialSlideMobile = parseInt(carouselEl.getAttribute('data-initial-slide-mobile'), 10);

    // Define every breakpoint so an unchecked setting explicitly falls back to
    // slide 0 rather than inheriting another breakpoint's configured value.
    // Breakpoints: mobile 0-600px, tablet 601-1024px, laptop 1025-1440px,
    // desktop 1441-2199px, and large desktop 2200px+.
    var swiperBreakpoints = {
      0: {
        initialSlide: isNaN(initialSlideMobile) ? 0 : initialSlideMobile
      },
      601: {
        initialSlide: isNaN(initialSlideTablet) ? 0 : initialSlideTablet
      },
      1025: {
        initialSlide: isNaN(initialSlideLaptop) ? 0 : initialSlideLaptop
      },
      1441: {
        initialSlide: isNaN(initialSlideDesktop) ? 0 : initialSlideDesktop
      },
      2200: {
        initialSlide: isNaN(initialSlideLarge) ? 0 : initialSlideLarge
      }
    };

    var swiperConfig = {
      speed: 600,
      grabCursor: true,
      slidesPerView: 'auto',
      centeredSlides: true,
      loop: true,
      spaceBetween: 0,
      observer: true,
      observeParents: true,

      slideToClickedSlide: true,
      breakpoints: swiperBreakpoints,
      navigation: {
        nextEl: carouselEl.querySelector('.swiper-button-next'),
        prevEl: carouselEl.querySelector('.swiper-button-prev'),
      },

      initialTransitionCount: 0,
      _viewportTriggered: false,
    };

    // Merge in the event handlers
    swiperConfig.on = {
        sliderMove: function() {
          this._userInteracted = true;
        },
        beforeTransitionStart: function() {
          if (!this._viewportTriggered) return;

          var activeSlide = this.slides[this.activeIndex];
          var bgPhoto = activeSlide.querySelector('.video-block__background-photo');

          if (bgPhoto && bgPhoto.getAttribute('data-video')) {
            var videoUrl = bgPhoto.getAttribute('data-video');
            var videoLoad = bgPhoto.querySelector('.video-load');

            if (videoLoad && !videoLoad.querySelector('video')) {
              var video = document.createElement('video');
              video.src = videoUrl;
              video.autoplay = true;
              video.loop = true;
              video.muted = true;
              video.playsInline = true;
              videoLoad.appendChild(video);
            }
          }
        },
        sliderFirstMove: function() {
          //console.log('before first move');
        },
        slideChange: function(){
          var activeSlide = this.slides[this.activeIndex];
          var slideIndex = activeSlide.getAttribute('data-swiper-slide-index');
          var isDuplicate = activeSlide.classList.contains('video-block-is-duplicate');
          //console.log('Active slide data-swiper-slide-index:', slideIndex, 'is duplicate:', isDuplicate);
        },
        transitionStart: function(){
          var modals = this.el.querySelectorAll('.youtube-video-modal');
          Array.prototype.forEach.call(modals, function(modal){
            modal.remove();
          });

          var videos = this.el.querySelectorAll('video');
          Array.prototype.forEach.call(videos, function(video){
            video.pause();
          });
        },
        transitionEnd: function(){
          this.initialTransitionCount++;

          var activeSlide = this.slides[this.activeIndex];
          var bgPhoto = activeSlide.querySelector('.video-block__background-photo');

          if (this._userInteracted) {
            var innerDiv = activeSlide.querySelector('.video-block__review-item > div');
            if (innerDiv) {
              innerDiv.click();
            }
            this._userInteracted = false;
          }

          var activeSlideVideo = activeSlide.querySelector('video');
          if (activeSlideVideo) {
            var modals = this.el.querySelectorAll('.youtube-video-modal');
            Array.prototype.forEach.call(modals, function(modal){
              modal.remove();
            });

             activeSlideVideo.play();
            //this.slideToLoop(this.realIndex, 600);
          }

          // Mutation observer for pagination
          if (this.el.getAttribute('data-has-duplicates') === 'true') {
            var paginationFill = document.querySelector('.swiper-pagination-progressbar-fill');
            if (paginationFill && !paginationFill._observer) {
              paginationFill._observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                  if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                    var transform = paginationFill.style.transform;
                    var scaleMatch = transform.match(/scaleX\(([^)]+)\)/);
                    if (scaleMatch) {
                      var originalScale = parseFloat(scaleMatch[1]);
                      //console.log('original scaleX value:', originalScale);
                      var newScale = originalScale * 2;
                      if (newScale > 1) {
                        newScale = newScale - 1;
                      }
                      //console.log('updated scaleX value:', newScale);
                      paginationFill._observer.disconnect();
                      paginationFill.style.transform = transform.replace(/scaleX\(([^)]+)\)/, 'scaleX(' + newScale + ')');
                      paginationFill._observer.observe(paginationFill, {
                        attributes: true,
                        attributeFilter: ['style']
                      });
                    }
                  }
                });
              });
              paginationFill._observer.observe(paginationFill, {
                attributes: true,
                attributeFilter: ['style']
              });
            }
          }
        },
        slideChangeTransitionEnd: function(){
          var sliderEl = this.el;
          var pendingYoutubeId = sliderEl.getAttribute('data-pending-youtube-id');
          var pendingVideoFull = sliderEl.getAttribute('data-pending-video-full');

          if (pendingYoutubeId || pendingVideoFull) {
            sliderEl.removeAttribute('data-pending-youtube-id');
            sliderEl.removeAttribute('data-pending-video-full');

            var activeSlide = this.slides[this.activeIndex];
            openModal(activeSlide, pendingYoutubeId, pendingVideoFull);
          }
        }
      };

    var swiper = new Swiper(carouselEl, swiperConfig);

    swiper.on('init', function () {
      swiper.update();
      swiper.slideToLoop(swiper.activeIndex, 0);
    });

    setTimeout(function() {
      swiper.update();
    }, 100);

    // Store swiper instance on the element for later access
    carouselEl._swiper = swiper;

    // Viewport checker for initial load
    var $ = jQuery;
    $(carouselEl).viewportChecker({
      offset: -500,
      callbackFunction: function(elem, action){
        // Change datasrc to src for images
        $(elem).find('img[datasrc]').each(function() {
          var img = $(this);
          img.attr('src', img.attr('datasrc'));
          img.removeAttr('datasrc');
        });

        // Set flag to indicate viewport has triggered
        swiper._viewportTriggered = true;

        // Autoplay video on active slide when first entering viewport
        setTimeout(function() {
          var activeSlide = swiper.slides[swiper.activeIndex];
          if (activeSlide) {
            var bgPhoto = activeSlide.querySelector('.video-block__background-photo');

            if (bgPhoto && bgPhoto.getAttribute('data-video')) {
              var videoUrl = bgPhoto.getAttribute('data-video');
              var videoLoad = bgPhoto.querySelector('.video-load');

              if (videoLoad && !videoLoad.querySelector('video')) {
                var video = document.createElement('video');
                video.src = videoUrl;
                video.autoplay = true;
                video.loop = true;
                video.muted = true;
                video.playsInline = true;
                videoLoad.appendChild(video);

                video.addEventListener('canplay', function() {
                  this.play();
                });
              } else if (videoLoad) {
                var existingVideo = videoLoad.querySelector('video');
                if (existingVideo) {
                  existingVideo.play();
                }
              }
            }
          }
        }, 100);
      }
    });
  }

  // Click handler for opening modals - delegated on document
  document.addEventListener('click', function(e) {
    var target = e.target.closest('.video-block__background-photo[data-youtube-id], .video-block__background-photo[data-video-full], .video-block__content');
    if (!target) return;

    var bgPhoto;
    if (target.classList.contains('video-block__background-photo')) {
      bgPhoto = target;
    } else if (target.classList.contains('video-block__content')) {
      bgPhoto = target.closest('.swiper-slide').querySelector('.video-block__background-photo');
    }

    if (!bgPhoto) return;

    var youtubeId = bgPhoto.getAttribute('data-youtube-id') || '';
    var videoFull = bgPhoto.getAttribute('data-video-full') || '';

    if (youtubeId || videoFull) {
      if (e.target.closest('.youtube-video-modal') || e.target.closest('.close-modal')) return;

      var currentSlide = bgPhoto.closest('.swiper-slide');
      var index = parseInt(currentSlide.getAttribute('data-video-slide-index')) || 0;

      if (currentSlide.classList.contains('swiper-slide-active')) {
        openModal(currentSlide, youtubeId, videoFull);
      } else {
        var carouselEl = bgPhoto.closest('.video-block-carousel');
        var sliderEl = carouselEl ? carouselEl : document.querySelector('[data-video-block-slider]');
        sliderEl.setAttribute('data-pending-youtube-id', youtubeId);
        sliderEl.setAttribute('data-pending-video-full', videoFull);

        var swiper = carouselEl && carouselEl._swiper;
        if (swiper) {
          swiper.slideToLoop(index);
        }
      }
    }
  });

  // Initialize all video block carousels on the page
  function initAllCarousels() {
    var carousels = document.querySelectorAll('.video-block-carousel');
    Array.prototype.forEach.call(carousels, function(carouselEl) {
      // Skip if already initialized
      if (carouselEl._swiper) return;
      initVideoBlockCarousel(carouselEl);
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCarousels);
  } else {
    initAllCarousels();
  }

})();